export const dialogTheme = {
  css: ({ dt: any }: any) => `
    .p-dialog {
      width: 40vw !important;
      min-width: 230px;
    }

    
    .p-dialog-title {
      font-size: 24px;
      font-weight: 700;
    }
    
    .p-dialog-header {
      padding: 16px;
    }
    .p-dialog .p-dialog-header .p-dialog-close-button {
      color: var(--p-sd-text-primary);
    }
    .p-dialog .p-dialog-header .p-dialog-close-button:hover {
      color: var(--p-sd-text-primary);
      background: var(--p-button-text-primary-hover-background);
      
    }
    
    p.dialog-content {
      margin: 0 0 16px 0;
    }

    p.confirm-message {
      margin: 0 0 8px 0;
      font-weight: 600;
    }

    
    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      padding-top: 16px;
    }
    `
};
